import { WorkflowStatus } from '../enum/workflow-status.enum';

export const workflowService = {
  convertActiveToWorkflowStatus: (active: boolean) => (active ? WorkflowStatus.Published : WorkflowStatus.Draft),

  convertWorkflowStatusToActive: (status: WorkflowStatus) => {
    if (!status) {
      return false;
    }

    return status === WorkflowStatus.Published;
  },
};
